export default [
  {
    path: '',
    name: 'apps-ticket-list',
    component: () => import(/* webpackChunkName: "apps-ticket-list" */ '@/apps/ticket/pages/TicketListPage.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: 'new',
    name: 'apps-ticket-new',
    component: () => import(/* webpackChunkName: "apps-ticket-new" */ '@/apps/ticket/pages/TicketFormPage.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: 'edit/:id',
    name: 'apps-ticket-edit',
    component: () => import(/* webpackChunkName: "apps-ticket-edit" */ '@/apps/ticket/pages/TicketFormPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
